module.exports = __webpack_public_path__ + "static/scale-model-of-tucson-arizona-ba166c834aadb5ba23108f1b37c0a29f.png";